// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pi-0";
export var animationContainer = "_pi-1";
export var itemPrice = "_pi-a";
export var itemizedContent = "_pi-9";
export var itemizedHeader = "_pi-7";
export var itemizedRow = "_pi-8";
export var itemizedSection = "_pi-6";
export var modalContent = "_pi-2";
export var orderName = "_pi-3";
export var refundOption = "_pi-4";
export var refundOptionsContainer = "_pi-5";
export var shippingLabel = "_pi-b";
export var totalRow = "_pi-c";